import { SanityDistributorList } from '../../types/generated/graphql-types'
import { DistributorListProps } from '../components/blocks/DistributorList/DistributorList'
import { notEmpty } from '../utilities/filters'
import { mapSanityLinkToInternalExternalLink } from './LinkMapper'

export const sanityDistributorListToDistributorListProps = ({
  columns,
  title,
  _rawPreamble,
}: SanityDistributorList): DistributorListProps => ({
  preamble: _rawPreamble,
  title: title ?? undefined,
  columns: columns?.filter(notEmpty)?.map(col => ({
    title: col?.title ?? '',
    items: col.items?.filter(notEmpty)?.map(item => ({
      text: item?.description ?? undefined,
      link: item?.link ? mapSanityLinkToInternalExternalLink(item?.link) : undefined,
    })),
  })),
})
